// extracted by mini-css-extract-plugin
export default {"add-company__stage-cont":"AddCompanyForm_add-company__stage-cont__TIBhT"};